<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :selectShow="false"
      :show="false"
      :submitData="submitData"
      @success="onSuccess"
      :goback="true"
    >
    </common-top-form>

    <common-table
      :data="tableData"
      ref="commonTable"
      :isShow="false"
      @handleChange="getPage"
      :width="100"
    >
      <el-table-column
        prop="acqCode"
        min-width="150"
        label="支付通道名称"
      ></el-table-column>
      <el-table-column
        prop="acqMerCode"
        min-width="100"
        label="通道商户编码"
      ></el-table-column>
      <!-- 新增 -->
      <el-table-column
        prop="merType"
        label="商户类别"
        min-width="150"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.merType == 1">小微户</span>
          <span v-else-if="scope.row.merType == 2">个体户</span>
          <span v-else-if="scope.row.merType == 3">企业户</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="acqUid"
        min-width="120"
        label="当前通道"
        :formatter="formatterTableData"
      >
        <template slot-scope="scope">
          {{ saveChooseShow(scope.row.acqUid) }}
        </template>
      </el-table-column>

      <el-table-column
        prop="acqMerName"
        label="通道商户名称"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="业务状态"
        min-width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">正常</span>
          <span v-else-if="scope.row.status == 1">未开通（审核中）</span>
          <span v-else-if="scope.row.status == 2">失败</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="uploadStatus"
        label="图片上传状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.uploadStatus == 0">上传成功</span>
          <span v-else-if="scope.row.uploadStatus == 1">未上传</span>
          <span v-else-if="scope.row.uploadStatus == 2">审核中</span>
          <span v-else-if="scope.row.uploadStatus == 3">上传失败</span>
          <span v-else-if="scope.row.uploadStatus == 4">修改失败</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="feeChangeStatus"
        label="费率变更状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.feeChangeStatus == 0">无需变更</span>
          <span v-else-if="scope.row.feeChangeStatus == 1">需要变更</span>
          <span v-else-if="scope.row.feeChangeStatus == 2">变更失败</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="cardChangeStatus"
        label="结算变更"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.cardChangeStatus == 0">无需变更</span>
          <span v-else-if="scope.row.cardChangeStatus == 1">需要变更</span>
          <span v-else-if="scope.row.cardChangeStatus == 2">变更失败</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createDate"
        label="创建时间"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="remarks"
        label="备注"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column label="操作" min-width="200" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="deleteButton(scope.row)"
            v-if="scope.row.status != 0"
            >删除
          </el-button>
          <el-button type="text" @click="handleDelete(scope.row)"
            >注销
          </el-button>
        </template>
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FinanceService from "service/FinanceService";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "twoapppointsnewodetoJoyinfolook",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      saveChoose: [],
      isPage: false,
      page: {},
      formModel: {},
      impiementall: {},
      submitService: FinanceService.channelMerchant,
      tableData: [],
      status: [
        {
          dictKey: "0",
          dictValue: "未启动",
        },
        {
          dictKey: "1",
          dictValue: "进行中",
        },
        {
          dictKey: "2",
          dictValue: "已结束",
        },
        {
          dictKey: "3",
          dictValue: "已完成",
        },
      ],
    };
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    submitData() {
      const params = {
        merCode: JSON.parse(this.$route.params.item).merCode,
        pId: this.impiementall.id,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  created() {
    console.log(
      JSON.parse(this.$route.params.item).merCode,
      "this.$route.params.itemthis.$route.params.item"
    );
    this.impiementall = JSON.parse(this.$route.params.item);
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
    this.getTypeNames("上游渠道号", (res) => {
      this.saveChoose = res;
    });
  },
  watch: {},
  methods: {
    handleDelete(item) {
      this.showConfirm("是否注销？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },

    doDelete(id) {
      this.doLoad(
        FinanceService.deleteData,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.getList();
          });
        },
        "操作失败"
      );
    },
    deleteButton(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDeleteNew(item.id);
        })
        .catch(() => {});
    },
    doDeleteNew(id) {
      this.doLoad(
        FinanceService.deleteDataNew,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.getList();
          });
        },
        "操作失败"
      );
    },
    saveChooseShow(e) {
      console.log(e, "this.saveChoose");
      const foundItem = this.saveChoose.find((item) => item.dictKey === e);
      return foundItem ? foundItem.dictValue : "--"; // 如果找到，返回 dictValue，否则返回空字符串
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      console.log(this.submitService, this.submitData, "ddd");
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.onSuccess(res);
          this.isPage = false;
        },
        "信息获取失败"
      );
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/POSPmanage/channelMerchant.vue